import * as React from 'react';

import { Welcome } from '@entities/welcome';

const WelcomePage = () => {
	return <Welcome />;
};

export default WelcomePage;
